export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-list-3f3221f62d7b6ab4795a4b7a29ba228f.svg";